export enum ModuleLevel {
  NONE = 'none',
  SOME = 'some',
  ALL = 'all',
}
